import { Component } from "react"
import "./App.css"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import IconButton from "@mui/material/IconButton"
import SvgIcon from "@mui/material/SvgIcon"
import Tooltip from "@mui/material/Tooltip"
import Zoom from "@mui/material/Zoom"
import Fab from "@mui/material/Fab"
import Snackbar from "@mui/material/Snackbar"
import InputBase from "@mui/material/InputBase"
import { withStyles } from "@mui/styles"
import ExitToApp from "@mui/icons-material/ExitToApp"
import DeleteOutlined from "@mui/icons-material/DeleteOutlined"
import Close from "@mui/icons-material/Close"
import { withTranslation } from "react-i18next"
import clipboardCopy from "clipboard-copy"
import logo from "./assets/logo.svg"
import smallLogo from "./assets/small-logo.svg"
import { getObjectFitSize } from "./utilities"

const CustomTooltip = withStyles({
  tooltipPlacementTop: {
    marginBottom: "8px",
    filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25))",
  },
  tooltip: { backgroundColor: "white", color: "black", borderRadius: "8px" },
  arrow: { color: "white" },
})(Tooltip)

export default withTranslation()(
  class App extends Component {
    state = {
      picture: null,
      hotspots: [],
      hoveredHotspot: [],
      pictureCohordinates: {
        width: null,
        height: null,
        x: null,
        y: null,
      },
      snackbarOpen: false,
      mobile: null,
      fileName: "",
    }

    setPictureCohordinates = () => {
      const image = document.getElementById("uploaded-picture")

      if (image) {
        this.setState({
          pictureCohordinates: getObjectFitSize(
            image.width,
            image.height,
            image.naturalWidth,
            image.naturalHeight,
            image.getBoundingClientRect().left,
            image.getBoundingClientRect().top
          ),
        })
      }
    }

    updateDimensions = () => {
      const { mobile } = this.state

      if (window.innerWidth < 768) {
        !mobile && this.setState({ mobile: true })
      } else {
        mobile && this.setState({ mobile: false })
      }
    }

    componentDidMount() {
      this.updateDimensions()
      window.addEventListener("resize", this.updateDimensions)
      window.addEventListener("resize", this.setPictureCohordinates)
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions)
      window.removeEventListener("resize", this.setPictureCohordinates)
    }

    render() {
      const { t } = this.props
      const {
        picture,
        hotspots,
        hoveredHotspot,
        pictureCohordinates,
        snackbarOpen,
        mobile,
        fileName,
      } = this.state

      return mobile ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            backgroundColor: "#E6E2B1",
          }}
        >
          <div
            style={{
              margin: "auto",
              maxHeight: "100%",
              overflow: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#E6E2B1",
                textAlign: "center",
                padding: "32px 0 16px 0",
              }}
              className="notSelectable"
            >
              <img alt="" src={logo} style={{ marginBottom: "48px" }} />
              <Typography
                variant="h4"
                style={{
                  fontSize: "30px",
                  fontWeight: 600,
                  margin: "0 32px 8px 32px",
                  color: "#181818",
                }}
              >
                {t`Your screen is too small`}
              </Typography>
              <Typography
                variant="h6"
                style={{ fontWeight: 300, margin: "0 32px", color: "#181818" }}
              >{t`Try connecting from a larger device`}</Typography>
            </div>
          </div>
        </div>
      ) : picture ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            backgroundColor: "#E6E2B1",
          }}
          className="notSelectable"
        >
          <div
            style={{
              width: "100%",
              height: "72px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {hotspots.map(({ x, y }) => (
              <CustomTooltip
                key={`tooltip-${x}-${y}`}
                title={
                  <InputBase
                    autoFocus
                    placeholder={t`Insert hotspot text`}
                    inputProps={{
                      style: {
                        fontSize: "1.5rem",
                        lineHeight: "2rem",
                        WebkitTextFillColor: "black",
                        textAlign: "center",
                        padding: "4px 8px",
                      },
                    }}
                    multiline
                    value={
                      hotspots.find(
                        (hotspotToFind) =>
                          hotspotToFind.x === x && hotspotToFind.y === y
                      ).text
                    }
                    onChange={(event) =>
                      this.setState(({ hotspots }) => ({
                        hotspots: [
                          ...hotspots.filter(
                            (hotspotToRemove) =>
                              hotspotToRemove.x !== x || hotspotToRemove.y !== y
                          ),
                          {
                            ...hotspots.find(
                              (hotspotToFind) =>
                                hotspotToFind.x === x && hotspotToFind.y === y
                            ),
                            text: event.target.value,
                          },
                        ],
                      }))
                    }
                  />
                }
                enterTouchDelay={0}
                arrow
                placement="top"
              >
                <IconButton
                  style={{
                    position: "absolute",
                    left:
                      x * pictureCohordinates.width -
                      20 +
                      pictureCohordinates.x,
                    top:
                      y * pictureCohordinates.height -
                      20 +
                      pictureCohordinates.y,
                    color: "black",
                    background: "white",
                    filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25))",
                  }}
                  onMouseEnter={() => this.setState({ hoveredHotspot: [x, y] })}
                  onMouseLeave={() => this.setState({ hoveredHotspot: [] })}
                  onClick={() =>
                    this.setState(({ hotspots }) => ({
                      hotspots: hotspots.filter(
                        (hotspotToRemove) =>
                          hotspotToRemove.x !== x || hotspotToRemove.y !== y
                      ),
                    }))
                  }
                >
                  {hoveredHotspot[0] === x && hoveredHotspot[1] === y ? (
                    <DeleteOutlined />
                  ) : (
                    <SvgIcon>
                      <svg viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
                        />
                      </svg>
                    </SvgIcon>
                  )}
                </IconButton>
              </CustomTooltip>
            ))}
            <img alt="" src={smallLogo} style={{ marginLeft: "32px" }} />
            <Typography
              variant="h5"
              style={{
                width: "calc(100% - 328px)",
                fontWeight: 600,
                color: "#181818",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                margin: "0 16px",
                textAlign: "center",
              }}
              className="notSelectable"
            >{t`Click anywhere on the picture`}</Typography>
            <div style={{ paddingRight: "16px" }}>
              <IconButton
                style={{ color: "black" }}
                onClick={() => this.setState({ picture: null, fileName: "" })}
              >
                <ExitToApp style={{ width: "32px", height: "32px" }} />
              </IconButton>
            </div>
          </div>
          <img
            id="uploaded-picture"
            src={picture}
            alt=""
            style={{
              width: "calc(100% - 32px)",
              height: "calc(100% - 88px)",
              margin: "0 16px 16px 16px",
              objectFit: "contain",
            }}
            onLoad={(event) =>
              this.setState({
                pictureCohordinates: getObjectFitSize(
                  event.target.width,
                  event.target.height,
                  event.target.naturalWidth,
                  event.target.naturalHeight,
                  event.target.getBoundingClientRect().left,
                  event.target.getBoundingClientRect().top
                ),
              })
            }
            onMouseDown={(event) => {
              if (
                pictureCohordinates.x < event.clientX &&
                pictureCohordinates.x + pictureCohordinates.width >
                  event.clientX &&
                pictureCohordinates.y < event.clientY &&
                pictureCohordinates.y + pictureCohordinates.height >
                  event.clientY
              ) {
                this.setState(({ hotspots }) => ({
                  hotspots: [
                    ...hotspots,
                    {
                      text: "",
                      x:
                        Math.min(
                          Math.max(event.clientX - pictureCohordinates.x, 20),
                          pictureCohordinates.width - 20
                        ) / pictureCohordinates.width,
                      y:
                        Math.min(
                          Math.max(event.clientY - pictureCohordinates.y, 20),
                          pictureCohordinates.height - 20
                        ) / pictureCohordinates.height,
                    },
                  ],
                }))
              }
            }}
          />
          <Zoom in={hotspots[0] && hotspots.some(({ text }) => text)}>
            <Fab
              color="primary"
              style={{
                position: "absolute",
                right: "24px",
                bottom: "24px",
                backgroundColor: "#181818",
                color: "white",
                borderRadius: "16px",
              }}
              onClick={() => {
                clipboardCopy(`
nome: <inserisci nome>
tipo: solo-sfondo
sfondo: ${fileName}
palloncini:${hotspots
                  .filter(({ text }) => text)
                  .map(
                    ({ x, y, text }) =>
                      `
  - x: ${2 * x - 1}
    y: ${2 * y - 1}
    testo: ${text}
`
                  )
                  .join("")}
---
`)

                this.setState({ snackbarOpen: true })
              }}
              autoHideDuration={5000}
            >
              <SvgIcon>
                <svg
                  style={{ width: "24px", height: "24px" }}
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M14.6,16.6L19.2,12L14.6,7.4L16,6L22,12L16,18L14.6,16.6M9.4,16.6L4.8,12L9.4,7.4L8,6L2,12L8,18L9.4,16.6Z"
                  />
                </svg>
              </SvgIcon>
            </Fab>
          </Zoom>
          <Snackbar
            open={snackbarOpen}
            onClose={(_, reason) => {
              if (reason === "clickaway") {
                return
              }

              this.setState({ snackbarOpen: false })
            }}
            message={t`Code copied to clipboard`}
            action={
              <IconButton
                style={{ color: "white" }}
                onClick={() => this.setState({ snackbarOpen: false })}
              >
                <Close />
              </IconButton>
            }
            ContentProps={{ style: { height: "44px", borderRadius: "16px" } }}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            autoHideDuration={5000}
          />
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              backgroundColor: "#E6E2B1",
            }}
            className="notSelectable"
          >
            <div
              style={{
                margin: "auto",
                maxHeight: "100%",
                overflow: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#E6E2B1",
                  textAlign: "center",
                  padding: "32px 0 16px 0",
                }}
              >
                <img alt="" src={logo} style={{ marginBottom: "48px" }} />
                <Typography
                  variant="h4"
                  style={{
                    fontSize: "30px",
                    fontWeight: 600,
                    margin: "0 32px 8px 32px",
                    color: "#181818",
                  }}
                >
                  {t`Choose a picture to get started`}
                </Typography>
                <Button
                  onClick={() => this.upload.click()}
                  style={{
                    margin: "48px",
                    minHeight: "48px",
                    borderRadius: "16px",
                    fontSize: "18px",
                    padding: "8px 16px",
                  }}
                  variant="contained"
                >{t`Upload picture`}</Button>
              </div>
            </div>
          </div>
          <input
            type="file"
            hidden
            accept="image/png, image/jpeg"
            ref={(ref) => (this.upload = ref)}
            onChange={(event) => {
              event.stopPropagation()
              event.preventDefault()

              let target = event.target || window.event.srcElement

              if (FileReader && target.files && target.files.length) {
                let fileReader = new FileReader()

                fileReader.onload = () => {
                  this.setState({ picture: fileReader.result, hotspots: [] })
                }

                fileReader.readAsDataURL(target.files[0])

                this.setState({
                  fileName: target.files[0].name,
                })
              }
            }}
          />
        </>
      )
    }
  }
)
